import $ from 'jquery';

document.addEventListener('click', function(e) {
    const target = e.target.closest('.js-show-more');

    if (target) {
        e.preventDefault();

        const showMoreContainer = e.target.closest('.js-show-more-container');
        const showMoreList = showMoreContainer.querySelector('.js-show-more-list');

        const limit = +showMoreContainer.dataset.limit;
        const totalItemsCount = +showMoreContainer.dataset.count;
        const start = +showMoreContainer.dataset.start;
        const end = start + limit - 1;

        if (!target.startItem) {
            target.startItem = start;
        }
        if (!target.endItem) {
            target.endItem = end;
        }

        const href = target.dataset.href;
        const url = `${href}?start=${target.startItem}&end=${target.endItem}`;

        $.ajax({
            type: 'GET',
            url: url,
            success: function(response) {
                showMoreList.innerHTML += response;

                target.startItem = target.endItem + 1;
                target.endItem = target.startItem + limit - 1;

                if (target.startItem > totalItemsCount) {
                    target.classList.add('hidden');
                }
            },
            error: function() {}
        });
    }
});
